// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> malvern-hill-apartment-homes
// Generated: 2026-11-03T23:00:42.067Z
// Counts: 2 design, 74 content, 28 slot group, 2 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Studio, 1 &amp; 2 Bedroom Apartments Near KU Medical Center</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Malvern Hill Apartment Homes in Kansas City, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartment Amenities at Malvern Hill Apartment Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Malvern Hill Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Get in Touch</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers to the questions residents ask most at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio, 1 &amp; 2 Bedroom Floor Plans in Kansas City, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Take the Next Step</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photo Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Inside Our Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Explore the Neighborhood Around Malvern Hill Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Getting Around</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-friendly living at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pets Welcome at Malvern Hill Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access at Malvern Hill Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pay Rent and Submit Maintenance Requests</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour at Malvern Hill Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Book Your Visit</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Take a Virtual Tour of Malvern Hill Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour Our Studio 1, Studio 2, </h2><h2>and A2 Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><strong>Amenities that simplify your day.</strong> At Malvern Hill Apartment Homes, the details are designed to make home feel easy—from off-street parking and available garages to controlled-access entries and a convenient laundry facility. When you want to unwind, head to the outdoor resort-style pool or bring your pet into the perks of the <a class=\"richtext-link\" href=\"/pet-policy\">Pet Royalty Program</a>.</p><p>Inside your studio, one or two-bedroom apartment, everyday function meets polished style with an all-electric kitchen, full-size refrigerator, dishwasher, upgraded cabinets and light fixtures, air conditioning, and select stainless steel appliances, ceiling fans, or patio/balcony spaces. Studios may also include electricity in rent, adding one more practical advantage in Rosedale. See the finishes for yourself in the <a class=\"richtext-link\" href=\"/gallery\">photo gallery</a>.</p>",
    "generatedValue": null,
    "mappedField": "property_amenities_blurb"
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Malvern Hill Apartment Homes offers a range of floor plans designed to fit any lifestyle, from an efficient studio to a two-bedroom, two-bathroom layout. Every home includes an all-electric kitchen with a dishwasher and full-size refrigerator, plus a patio or balcony.</p><p>Studio apartments start around 420 square feet, offering an efficient layout that makes the most of every inch without sacrificing comfort. Our one-bedroom apartments in Kansas City, KS offer around 620 to 750 square feet of living space, with <a class=\"richtext-link\" href=\"/amenities\">upgraded cabinets and light fixtures</a> available in select homes. Two-bedroom apartments range up to 920 square feet and are available in one- or two-bathroom layouts, giving residents room to spread out.</p><p>Take a <a class=\"richtext-link\" href=\"/virtual-tours\">self-guided 360-degree tour</a> online or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule</a> a guided, in-person tour to find the floor plan that fits best at Malvern Hill Apartment Homes.</p>",
    "generatedValue": null,
    "mappedField": "property_floorplans_blurb"
  },
  "gallery-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><strong>See the details before you visit.</strong> Browse Malvern Hill Apartment Homes through photos that move from bright, efficient interiors to laid-back community spaces. Picture an all-electric kitchen with upgraded cabinetry, polished fixtures, and room for everyday routines; then look for living areas that open toward fresh air in select homes with a patio or balcony. Outside, the gallery brings the setting into focus with controlled-access entries, landscaped grounds, and the outdoor <a class=\"richtext-link\" href=\"/amenities\">resort-style pool</a> ready for warm afternoons. From studio spaces to two-bedroom layouts, each image gives you a clearer feel for finishes, flow, and the comfortable Rosedale address you’re considering. Want a closer look? Continue with <a class=\"richtext-link\" href=\"/virtual-tours\">virtual tours</a> or schedule a visit.</p>",
    "generatedValue": null,
    "mappedField": "property_gallery_blurb"
  },
  "interactive-map-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><strong>Explore Malvern Hill on the map.</strong> See available studio, one and two-bedroom apartments near Rosedale connections, with KU Medical Center, Rainbow Boulevard, Southwest Boulevard, I-35, dining, trails, and downtown Kansas City all within easy reach.</p>",
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pet-policy-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><strong>Bring your favorite companion home.</strong> At Malvern Hill Apartment Homes pets can settle into a comfortable Rosedale routine with you, whether that means sunny window naps, a quick leash walk before errands, or fresh air from a select patio or balcony.</p><p>The community keeps pet life practical, too: off-street parking helps simplify vet and grooming trips, the laundry facility is handy after muddy paws, and the <a class=\"richtext-link\" href=\"/amenities\">Pet Royalty Program</a> adds an extra perk worth asking the office about. Review the pet guidelines below, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see how your next home in Kansas City can fit every member of your household.</p>",
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Black &amp; Veatch</p></li><li><p>Burns &amp; McDonnell</p></li><li><p>CBIZ</p></li><li><p>Cerner</p></li><li><p>KC Police Dept</p></li><li><p>KC Fire Dept.</p></li><li><p>KU Medical Center</p></li><li><p>Lockton</p></li><li><p>Polsinelli</p></li><li><p>KC University of Medical &amp; Biosciences</p></li><li><p>St. Luke's Health System</p></li><li><p>Active Military</p></li><li><p>University of Missouri - Kansas City</p></li><li><p>All Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p>Malvern Hill Apartment Homes offers <a class=\"richtext-link\" href=\"/floor-plans\">studio, one, and two-bedroom apartments</a> in Kansas City, Kansas. The <a class=\"richtext-link\" href=\"/neighborhood\">community sits close</a> to the University of Kansas Medical Center and downtown Kansas City, putting work, dining, and Westport within easy reach.</p><p>Every <a class=\"richtext-link\" href=\"/pet-policy\">pet-friendly</a> apartment includes ceiling fans, and residents have access to an outdoor resort-style pool and an on-site laundry facility. Controlled access doors and off-street parking, with garages available, are part of everyday life here.</p><p>Floor plans at Malvern Hill Apartment Homes go from cozy studios to spacious two-bedroom, two-bathroom homes, with finishes like stainless steel appliances and granite countertops available. Browse the full lineup on the Floor Plans page, then <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to see Malvern Hill Apartment Homes in person.</p>",
    "generatedValue": null,
    "mappedField": "property_long_description"
  },
  "residentaccess.help_title": {
    "overrideType": "VALUE",
    "customValue": "Need Help Accessing Your Account?",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.portal_title": {
    "overrideType": "VALUE",
    "customValue": "Manage Your Account Online",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "contactform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs and a sunset sky."
      }
    }
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "neighborhoodsection.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-5ed9-77e9-bead-173ec033bfa7.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rosedale Memorial Arch"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rosedale Memorial Arch, a WWI veterans monument modeled on the Arc de Triomphe"
      }
    }
  },
  "neighborhoodsection.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc981-3447-72c5-9e97-3f298e900c22.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rozarks Nature Trail"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rozarks Nature Trail, an urban trail for walking, hiking, and mountain biking"
      }
    }
  },
  "neighborhoodsection.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/019fc980-3337-711f-bfc1-fed1ddce7da7.webp"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Rosedale Bar-B-Q"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rosedale Bar-B-Q, a longtime Kansas City-style barbecue restaurant"
      }
    }
  },
  "neighborhoodsection.place_4": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "preferred-employer-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167602/01a01029-4688-779a-b3e2-6ae7fa546ec9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with lounge chairs and a sunset sky."
      }
    }
  },
  "sister-properties-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of West 39th Street apartment community"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of 46 Penn Apartment Homes community"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Cambria Luxury Apartment Homes community"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Bremerton Park Apartment Homes community"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Sheridan Ridge Townhomes community"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of Fiesta Square Apartments & Townhomes community"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "ec_dfab272c1783e692de43f46d",
      "ec_1e6ba9016bb4038acabde3ef",
      "ec_14dbb62393117d0f656e4dfd",
      "ec_ad2a18ff4d8020dc5638279f",
      "ec_5ef78c262a1f0073ebbf6b3a",
      "ec_546d26e1f627b3b9d48f8d65",
      "ec_8986cfd0ac66b1c767e4239e",
      "ec_bd6df3f6659dcfc9a6136510",
      "ec_23a1b92d0d43fb2848e00956",
      "ec_9d8f6d66ede8f57e644c4ca3",
      "ec_951c07d16a030040734d9596",
      "ec_d8865a7b7839a6e139660618",
      "ec_be606839496a3b3ef478fa83",
      "ec_54fb676485408aa0f7d9ce62",
      "ec_2e3ac2faf8cdf801b4d2e310",
      "ec_be2f6dc73047bad654f12c3d",
      "ec_0c91665f79ba438d1ebbea5a",
      "ec_5c0911ee7efc27c9c5b2ae71",
      "ec_51d8413c685ac5621def1786",
      "ec_ce988bcfd55962dd93178e19"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_c05d9f3b07648d7052661469",
      "ec_64d8a42ce1b70be056412368",
      "ec_2172307d5fc06cb89bb8284f",
      "ec_64aa6be038ed1ec39afa5167"
    ],
    "orderedIds": [
      "ec_ec1ab8a7bef4b1b01ed12096",
      "ec_45b034f0347e68979a0c17d0",
      "ec_58d3833de50c39ccaaf956c7",
      "ec_64afdcc6aad0c65e73797797",
      "ec_cf99ab041190e4ad6bc29aab",
      "ec_157b45244f459c7a53224480",
      "ec_101704d4edbaaacb0009d76f",
      "ec_bab26404f80b2fc7c7e17184",
      "ec_c5d0c8ab17f51305b157428d",
      "ec_7cfd40bac8f8cb9178846926",
      "ec_7d40a7279a8be98f51497ec3",
      "ec_2eec08db9ca619f40d36206b",
      "ec_64d8a42ce1b70be056412368",
      "ec_fa46373facbfe4bb0a9a04ef",
      "ec_f476a86227863ed8e5222ee5",
      "ec_7b32417b9c02b01d2dea70b5",
      "ec_7e46301174a7da95ec0629e9",
      "ec_c18e536344774c0c93ec3aad",
      "ec_20f65e125ac0bc0a68aa9395",
      "ec_4d569f152330df4291988e05",
      "ec_2172307d5fc06cb89bb8284f",
      "ec_00fa538fedf15d46ca55b4be",
      "ec_45719a41a96e8db4a2ee6982",
      "ec_64aa6be038ed1ec39afa5167",
      "ec_798fe9dd60a1e2a47c0f9e92",
      "ec_b285262e722e828bc8e8d19d",
      "ec_5c08188cbbc33e8c45eef73b",
      "ec_d6efdb0000579ff94937cf1a",
      "ec_968ea0d1cd989d1c992bacc2",
      "ec_f9d7b95ce2286a6ee8752651",
      "ec_c05d9f3b07648d7052661469",
      "ec_3c89992403bec165bce96faa",
      "ec_c8a6c42a94e5cd74f4ad6463",
      "ec_cc9fdea4e0936a6975b0012c",
      "ec_0260e8cde3f0d9db3195435a",
      "ec_b7c0b616bf370dca1c815271",
      "ec_f628da3267855da65760adb5",
      "ec_c0ff69fdb440347e2dcba6ce",
      "ec_5697bfd08ab8d153d85aa36f",
      "ec_5c4e515f6c237014105b957c",
      "ec_89071658e299a64624325d8d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
